import { render, staticRenderFns } from "./coachInfoManage.vue?vue&type=template&id=9a8f0480&scoped=true"
import script from "./coachInfoManage.vue?vue&type=script&lang=ts"
export * from "./coachInfoManage.vue?vue&type=script&lang=ts"
import style0 from "./coachInfoManage.vue?vue&type=style&index=0&id=9a8f0480&prod&scoped=true&lang=stylus"
import style1 from "./coachInfoManage.vue?vue&type=style&index=1&id=9a8f0480&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8f0480",
  null
  
)

export default component.exports